import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import { Observable, forkJoin, of } from 'rxjs';

@Pipe({
  name: 'translation',
  standalone: true,
})
export class TranslationPipe implements PipeTransform {
  constructor(private _translateService: TranslateService) {
    //TODO Review delete
    // this._translateService.addLangs(['ca', 'en', 'es']);
    // this._translateService.setDefaultLang('ca');
    // this._translateService.use('ca');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform(value: any[], labelAttr: string, key?: string): Observable<any[]> {
    if (!value || value.length === 0) {
      return of([]);
    }

    const translationObservables = value.map((item) => {
      const isValueActiveAndHasId: boolean = item.active && !!item.id;
      const translation$ = this._translateService.get(item[labelAttr]).pipe(
        map((translatedValue) => ({
          ...item,
          [labelAttr]: isValueActiveAndHasId
            ? `${translatedValue}${item.id}`
            : translatedValue,
        })),
      );

      if (key && item[key]) {
        const nestedTranslations$ = this.transform(item[key], labelAttr, key);
        return forkJoin([translation$, nestedTranslations$]).pipe(
          map(([translatedItem, translatedChildren]) => ({
            ...translatedItem,
            [key]: translatedChildren,
          })),
        );
      }

      return translation$;
    });

    return forkJoin(translationObservables);
  }
}
